"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

var _nicaLocatorCore = require("../../nicaLocatorCore");

var _fullScreen = _interopRequireDefault(require("../../_common/dialog/fullScreen"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RateLimitDialog = function RateLimitDialog(_ref) {
  var open = _ref.open;

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      logo = _useContext.images.logo;

  return /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    onClose: function onClose() {},
    open: open
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column h100"
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "sticky",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "home-toolbar-title-container text-align-left flex w100"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "nica logo",
    className: "login-nica-logo"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 country-blocked-message bodyFont text-align-center"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "country-blocked-icon"
  }, /*#__PURE__*/_react.default.createElement(_Block.default, {
    fontSize: "inherit"
  })), /*#__PURE__*/_react.default.createElement("p", null, "Thank you for using the NICA Infusion Center Locator, the premier resource for connecting patients with infusion centers."), /*#__PURE__*/_react.default.createElement("p", null, "Your search behavior has been flagged as suspicious activity so you have been temporarily blocked from using the Locator."), /*#__PURE__*/_react.default.createElement("p", null, "If you believe you have received this message in error or would like to explore data that may be available through a partnership, please contact the NICA team at ", /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:locator@infusioncenter.org"
  }, "locator@infusioncenter.org"), "."), /*#__PURE__*/_react.default.createElement("p", null, "If you are not a bot and your situation requires extensive utilization in a short period of time, please let us know and we will be happy to assist!"))));
};

var _default = RateLimitDialog;
exports.default = _default;